import { useState } from "react";

import { useModal } from "@/sx-layout/components/plotmap/hooks/useModal";
import { getCopyMachineCoords } from "@/sx-layout/components/plotmap/util/coords";

export const useMachineEditorModal = (props?: { mapX?: number; mapY?: number; mapRatio: number }) => {
  const modal = useModal();
  const [duplicate, setDuplicate] = useState<boolean>(false);
  const [x, setX] = useState<number>(0);
  const [y, setY] = useState<number>(0);

  const open = (option?: { duplicate: boolean; x: number; y: number }) => {
    setDuplicate(!!option?.duplicate);
    const { x: copyX, y: copyY } = getCopyMachineCoords(
      {
        x: option?.x ?? 0,
        y: option?.y ?? 0,
      },
      { width: props?.mapX ?? 0, height: props?.mapY ?? 0, ratio: props.mapRatio }
    );
    setX(copyX);
    setY(copyY);
    modal.open();
  };

  const close = () => {
    modal.close();
    setDuplicate(false);
    setX(0);
    setY(0);
  };

  return {
    isOpen: modal.isOpen,
    duplicate,
    x,
    y,
    open,
    close,
  };
};
